export const CERTIFICADO_DEFICIENCIA_IMPRESSAO_SOLICITADA = 'CERTIFICADO_DEFICIENCIA_IMPRESSAO_SOLICITADA';
export const CERTIFICADO_DEFICIENCIA_IMPRESSAO_RECEBIDA = 'CERTIFICADO_DEFICIENCIA_IMPRESSAO_RECEBIDA';
export const CERTIFICADO_DEFICIENCIA_ERRO_IMPRESSAO_RECEBIDO = 'CERTIFICADO_DEFICIENCIA_ERRO_IMPRESSAO_RECEBIDO';
export const CERTIFICADO_DEFICIENCIA_LIMPAR_MENSAGEM = 'CERTIFICADO_DEFICIENCIA_LIMPAR_MENSAGEM';
export const CERTIFICADO_DEFICIENCIA_NAO_ENCONTRADA = 'CERTIFICADO_DEFICIENCIA_NAO_ENCONTRADA';
export const CERTIFICADO_DEFICIENCIA_ERRO_ELO = 'CERTIFICADO_DEFICIENCIA_ERRO_ELO';
